// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { baseUrl } from "../../../../boot";

// export const fetchQuotes = createAsyncThunk(
//   "quotes/fetchQuotes",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const res = await axios.get(
//         `${baseUrl}crm/api/v1/get-quotations`,
//         {
//           headers: {
//             "auth-token": token,
//           },
//         }
//       );
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );


// const quoteSlice = createSlice({
//   name: "quotes",
//   initialState: {
//     loading: false,
//     error: null,
//     quotations: [],
//     page: 1,
//     size: 10,
//     success: false,
//   },

//   reducers: {},

//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchQuotes.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchQuotes.fulfilled, (state, action) => {
//         state.loading = false;
//         state.quotations = action.payload.quotations;
//         state.page = action.payload.page;
//         state.size = action.payload.size;
//         state.success = true;
//       })
//       .addCase(fetchQuotes.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default quoteSlice.reducer;



import { createSlice } from "@reduxjs/toolkit";
import { getQuoteList } from "../../reduxApi/admin/QuoteReduxApi";

const quoteSlice = createSlice({
    name: 'quote',
    initialState: {
        status: 'idel',
        isFiltered: false,
        quote: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteQuoteAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.quote.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.quote.splice(index, 1);
                }
            });
        },
        updateQuoteAction: (state, action) => {
            const index = state.quote.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.quote.splice(index, 1, { quotes: action.payload })
            }
        },
        addQuoteAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.quote.unshift({ quotes: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getQuoteList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getQuoteList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.quote = action.payload.data.quotations;
                console.log("state.quote",state.quote);
                
            })
    }
})
export const { deleteQuoteAction, updateQuoteAction, addQuoteAction, setFilteredStatus } = quoteSlice.actions
export default quoteSlice.reducer